class MailInputs {
  constructor(form) {
    this.form = form;
    this.inputs = [
      {
        name: 'subject',
        valid: false
      },
      {
        name: 'body',
        valid: false
      }
    ]
  }

  decorate() {
    this.clear();
    this.inputs.forEach(function validate(input){
      var $input = $(`[name='rmail[${input.name}]']`);
      var $parent = $input.parent();
      if ($input.val().length <= 0) {
        $input.addClass('invalid-form-element');
        var warning = $parent.find('.invalid-form-element-error')[0];

        if (warning == null) {
          $parent.append(`<div class="invalid-form-element-error">
             Please enter something here
          </div>`);
        }
      }
    })
  }

  clear() {
    this.inputs.forEach(function validate(input) {
      var $input = $(`[name='rmail[${input.name}]']`);
      $input.removeClass('invalid-form-element');
    });
    var warning = this.form.find('.invalid-form-element-error');
    warning.remove();
  }

}

window.MailInputs = MailInputs;
